import { useTranslation } from 'react-i18next';

const APP_URL = import.meta.env.VITE_APP_URL || 'https://app.jawabai.cloud';

// The landing site and the dashboard are different origins, so they cannot
// share localStorage. The current language travels in the link instead
// (?lang=ar|en); the dashboard reads it and hands it on to Keycloak.
export function useAppUrl() {
  const { i18n } = useTranslation();
  const lang = i18n.language === 'ar' ? 'ar' : 'en';
  return (path = '') => {
    const url = new URL(`${APP_URL}${path}`);
    url.searchParams.set('lang', lang);
    return url.toString();
  };
}
